/* Costack PDP extras - 23 Jun 2026 (v3: smart preselect)
 *  1) Card-style Pack selector (replaces the native dropdown).
 *     Preselects 5-Pack only when its price is in the £35-45 free-delivery sweet
 *     spot (the £8.50 line -> £38). Premium/cheaper lines default to Single jar
 *     to avoid sticker shock. 5-Pack still shown as Most popular.
 *  2) "Build your own box" link added to the PDP sets strip.
 * Product-page only. Drives the native <select name="options[Pack]"> so Dawn,
 * the subscribe module and the sticky bar all stay in sync.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  var handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];

  function money(p) { return '£' + (p / 100).toFixed(2); }

  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    var head = document.querySelector('.cstk-sets__headrow');
    if (head && !head.querySelector('.cstk-byob-link')) {
      var a = document.createElement('a');
      a.className = 'cstk-sets__all cstk-byob-link';
      a.href = '/pages/build-your-box';
      a.textContent = 'Build your own box';
      a.setAttribute('style', 'margin-left:12px;');
      head.appendChild(a);
      clearInterval(iv);
    }
    if (tries > 40) clearInterval(iv);
  }, 350);

  var CSS = [
    '.cstk-packs{display:flex;flex-direction:column;gap:8px;margin:8px 0 14px;}',
    '.cstk-pk{display:flex;align-items:center;gap:10px;width:100%;text-align:left;border:1.5px solid #e0d5c2;background:#fff;border-radius:10px;padding:11px 13px;cursor:pointer;font-family:inherit;position:relative;}',
    '.cstk-pk.is-sel{border-color:#b3641c;background:#fff8ef;}',
    '.cstk-pk__radio{flex:0 0 auto;width:18px;height:18px;border-radius:50%;border:2px solid #c9bda8;}',
    '.cstk-pk.is-sel .cstk-pk__radio{border-color:#b3641c;background:radial-gradient(#b3641c 42%,#fff 46%);}',
    '.cstk-pk__main{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px;}',
    '.cstk-pk__name{font-size:14px;font-weight:600;color:#231900;}',
    '.cstk-pk__badge{font-size:11px;font-weight:700;color:#1f7a37;}',
    '.cstk-pk__pop{position:absolute;top:-9px;left:12px;background:#b3641c;color:#fff;font-size:10px;font-weight:700;padding:2px 8px;border-radius:6px;letter-spacing:.3px;}',
    '.cstk-pk__right{flex:0 0 auto;text-align:right;display:flex;flex-direction:column;}',
    '.cstk-pk__price{font-size:15px;font-weight:700;color:#231900;}',
    '.cstk-pk__was{font-size:12px;color:#9a8e78;text-decoration:line-through;}',
    '.cstk-pk__save{font-size:11px;font-weight:700;color:#b3641c;}'
  ].join('');

  function initCards() {
    var sel = document.querySelector('select[name="options[Pack]"]');
    if (!sel || document.getElementById('cstk-packs')) return;
    var values = [].map.call(sel.options, function (o) { return o.value; });
    if (values.length < 2) return;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var byPack = {};
        prod.variants.forEach(function (v) { byPack[v.option1] = v; });

        var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

        var wrap = document.createElement('div'); wrap.id = 'cstk-packs'; wrap.className = 'cstk-packs';
        values.forEach(function (val) {
          var v = byPack[val]; if (!v) return;
          var price = v.price, was = v.compare_at_price;
          var save = (was && was > price) ? Math.round((1 - price / was) * 100) : 0;
          var free = price >= 3500;
          var pop = /5-?pack/i.test(val);
          var card = document.createElement('button');
          card.type = 'button'; card.className = 'cstk-pk'; card.setAttribute('data-pack', val);
          card.innerHTML =
            (pop ? '<span class="cstk-pk__pop">MOST POPULAR</span>' : '')
            + '<span class="cstk-pk__radio" aria-hidden="true"></span>'
            + '<span class="cstk-pk__main"><span class="cstk-pk__name">' + (val === 'Single Bottle' ? 'Single jar' : val) + '</span>'
            + (free ? '<span class="cstk-pk__badge">FREE UK delivery</span>' : '') + '</span>'
            + '<span class="cstk-pk__right"><span class="cstk-pk__price">' + money(price) + '</span>'
            + (save ? '<span class="cstk-pk__was">' + money(was) + '</span><span class="cstk-pk__save">Save ' + save + '%</span>' : '') + '</span>';
          wrap.appendChild(card);
        });

        var box = sel.closest('.product-form__input') || sel.parentNode;
        box.style.display = 'none';
        box.parentNode.insertBefore(wrap, box);

        function selectPack(val) {
          if (sel.value !== val) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          [].forEach.call(wrap.querySelectorAll('[data-pack]'), function (el) { el.classList.toggle('is-sel', el.getAttribute('data-pack') === val); });
        }
        wrap.addEventListener('click', function (e) {
          var c = e.target.closest('[data-pack]'); if (!c) return;
          selectPack(c.getAttribute('data-pack'));
        });

        var def = values[0];
        var five = byPack['5-Pack'];
        if (five && five.price >= 3500 && five.price <= 4500 && values.indexOf('5-Pack') >= 0) def = '5-Pack';
        selectPack(def);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCards);
  else initCards();
})();

/* Costack PDP fixes - 23 Jun 2026
 * (a) Suppress the SAVE 10% newsletter popup on product pages (buries the buy
 *     box for fresh mobile visitors). The form still shows on other pages.
 * (b) Mirror the sticky add-to-cart button to the real buy button so it can
 *     never get stuck on a stale "Sold out" after the 5-Pack auto-select.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  function isPopup(n) {
    if (!n || n.nodeType !== 1 || !n.querySelector) return false;
    var t = n.textContent || '';
    return /join the costack community|save\s*10%\s*off/i.test(t) && !!n.querySelector('input');
  }
  function unlock() {
    document.body.style.overflow = ''; document.documentElement.style.overflow = '';
    document.body.classList.remove('overflow-hidden');
  }
  function hidePopup(node) {
    var n = node;
    for (var i = 0; i < 7 && n.parentElement; i++) {
      var cs = getComputedStyle(n);
      if (cs.position === 'fixed' || cs.position === 'absolute' || /modal|popup|overlay|drawer/i.test((n.className || '').toString())) break;
      n = n.parentElement;
    }
    (n || node).style.setProperty('display', 'none', 'important');
    unlock();
  }
  function scanPopup(root) {
    if (isPopup(root)) { hidePopup(root); return; }
    if (root.querySelectorAll) {
      var els = root.querySelectorAll('div,section,aside,dialog,form');
      for (var i = 0; i < els.length; i++) { if (isPopup(els[i])) { hidePopup(els[i]); return; } }
    }
  }

  function realAtc() {
    var f = document.querySelector('product-form form, form[action*="/cart/add"]');
    return f && (f.querySelector('button[name="add"]') || f.querySelector('[type="submit"]'));
  }
  function syncSticky() {
    var sb = document.getElementById('cstk-satc'); if (!sb) return;
    var real = realAtc(); var btn = sb.querySelector('button'); if (!real || !btn) return;
    var off = !!real.disabled;
    btn.disabled = off;
    btn.textContent = off ? 'Sold out' : 'Add to cart';
  }

  function start() {
    scanPopup(document.body);
    var real = realAtc();
    if (real && 'MutationObserver' in window) {
      new MutationObserver(syncSticky).observe(real, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true, characterData: true });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var a = muts[i].addedNodes || [];
          for (var j = 0; j < a.length; j++) scanPopup(a[j]);
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    var n = 0, iv2 = setInterval(function () { syncSticky(); if (++n > 12) clearInterval(iv2); }, 400);
    syncSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Costack PDP popup kill v2 - 24 Jun 2026
 * The SAVE 10% popup is a Shopify Forms app embed (<shopify-forms-embed>) whose
 * teaser and expanded popup render INSIDE the element's shadow root, so the old
 * light-DOM text scan above never saw it on a fresh device (e.g. iOS 15 Safari).
 * Hide the host outright on product pages, via an injected <style> plus a JS
 * fallback. The popup still shows on every other page.
 */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  try {
    var s = document.createElement('style');
    s.id = 'cstk-popup-kill';
    s.textContent = 'shopify-forms-embed{display:none!important;visibility:hidden!important;}';
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
  function kill() {
    try {
      var els = document.querySelectorAll('shopify-forms-embed');
      for (var i = 0; i < els.length; i++) els[i].style.setProperty('display', 'none', 'important');
    } catch (e) {}
  }
  kill();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kill);
  try { new MutationObserver(kill).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  [300, 1000, 2500, 5000].forEach(function (t) { setTimeout(kill, t); });
})();
